import { isPhone, calculateMinWidth } from "@plugins";

const alphaSortingContainer = document.querySelector(".js-alpha-sorting-limit-width-init");

if (alphaSortingContainer && isPhone()) {
    limitAlphaSortingWidth(alphaSortingContainer);
}

function limitAlphaSortingWidth(alphaSortingContainer) {
    const alphaSortingWrap = alphaSortingContainer.querySelector(".js-alpha-sorting-list");

    if (!alphaSortingWrap) {
        const error = "Нет обертки";
        console.error(alphaSortingContainer, error);
    }

    const items = alphaSortingWrap.children;

    if (!items) {
        const error = new Error("Нет элементов списка");
        console.error(alphaSortingWrap, error);
    }

    let minWrapperWidth = 0;
    const elementMarginRight = "24px";

    minWrapperWidth = calculateMinWidth(items, 0, items.length, elementMarginRight);

    alphaSortingWrap.style.minWidth = `${minWrapperWidth}px`;
}
